import { memo } from "react";
import IconCb from "app/pages/.shared/static/icons/IconCb";
import IconMastercard from "app/pages/.shared/static/icons/IconMastercard";
import IconVisa from "app/pages/.shared/static/icons/IconVisa";
import IconAmex from "app/pages/.shared/static/icons/IconAmex";
import IconPaiement2x from "app/pages/.shared/static/icons/IconPaiement2x";
import IconPaiement4x from "app/pages/.shared/static/icons/IconPaiement4x";
import IconPaiement10x from "app/pages/.shared/static/icons/IconPaiement10x";
import IconPaypal from "app/pages/.shared/static/icons/IconPaypal";
import "./ReassurancePayment.scss";
import PropTypes from "prop-types";
import { CREDIT_CARDS_TYPES, PAYMENT_METHODS } from "app/constants";

const IconByTerms = {
	2: IconPaiement2x,
	4: IconPaiement4x,
	10: IconPaiement10x,
};

const ReassurancePayment = ({ paymentMethods }) => {
	const allUniquePaymentMethods = [
		...new Set(
			paymentMethods?.flatMap(
				paymentMethod => paymentMethod.constraints.acceptedCreditCardTypes
			)
		),
	];

	const isPaypal = paymentMethods?.find(
		paymentMethod => paymentMethod.code === PAYMENT_METHODS.PAYPAL
	);

	let AdditionalIcons = [];
	paymentMethods.forEach(paymentMethod =>
		paymentMethod?.termsChoices?.forEach(term => {
			if (term > 1) {
				AdditionalIcons.push(IconByTerms[term]);
			}
		})
	);

	return (
		<div className="reassurance-payment">
			<div className="reassurance-payment__payment">
				{allUniquePaymentMethods.map(code => {
					switch (code) {
						case CREDIT_CARDS_TYPES.CB:
							return (
								<div className="reassurance-payment__icon">
									<IconCb key={code} width={32} height={32} />
								</div>
							);
						case CREDIT_CARDS_TYPES.MASTERCARD:
							return (
								<div className="reassurance-payment__icon">
									<IconMastercard key={code} width={32} height={32} />
								</div>
							);
						case CREDIT_CARDS_TYPES.VISA:
							return (
								<div className="reassurance-payment__icon">
									<IconVisa key={code} width={32} height={32} />
								</div>
							);
						case CREDIT_CARDS_TYPES.AMEX:
							return (
								<div className="reassurance-payment__icon">
									<IconAmex key={code} width={32} height={32} />
								</div>
							);
						default:
							return null;
					}
				})}
				{isPaypal && (
					<div className="reassurance-payment__icon">
						<IconPaypal width={32} height={32} />
					</div>
				)}
				{AdditionalIcons.map((AdditionalIcon, index) => (
					<div className="reassurance-payment__icon" key={index}>
						<AdditionalIcon width={32} height={32} />
					</div>
				))}
			</div>
		</div>
	);
};

ReassurancePayment.propTypes = {
	paymentMethods: PropTypes.array,
};

ReassurancePayment.defaultProps = {
	paymentMethods: [],
};

export default memo(ReassurancePayment);
